<template>
   <div class="audio_playimg">
                       
                       <div class="audio_playimg_top">
                           <div class="audio_play_icon" @click="play" v-if="!audio.playing">
                               <img src="../assets/xiangning/djxx/audioPlay.png" alt="">
                           </div>
                           <div class="audio_play_icon" @click="pause" v-if="audio.playing">
                               <img src="../assets/xiangning/djxx/audiopuse.png" alt="">
                           </div>
                           <div class="audio_play_title">
                               {{ audioTitle }}
                           </div>
                       </div>
                       <!-- 进度条 -->
                       <div class="audio_contrals_progress">
                           <el-slider @change="progressChange" v-model="audio.currentTime"
                               :format-tooltip="realFormatSecond" @mousedown.native="progressState = true"
                               @mouseup.native="progressState = false" :max="audio.maxTime">
                           </el-slider>
                       </div>
                       <!-- 时间显示 -->
                       <div class="audio_time">
                           <span>{{ audio.currentTime | formatSecond }} </span><span>{{ audio.maxTime | formatSecond }}</span>
                       </div>
                       <audio ref="audio" id="audio" :src="kcSrc" @pause="onPause" @play="onPlay"
                           @timeupdate="onTimeupdate" @canplay="getDuration" @loadedmetadata="onLoadedmetadata">
                       </audio>

                   </div>
</template>

<script>
function realFormatSecond(second) {
    var secondType = typeof second;

    if (secondType === 'number' || secondType === 'string') {
        second = parseInt(second);

        var hours = Math.floor(second / 3600);
        second = second - hours * 3600;
        var mimute = Math.floor(second / 60);
        second = second - mimute * 60;

        return ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
    } else {
        return '00:00'
    }
}
export default {
    props: {
        kcSrc: {
            type: String,
            default: ''
        },
        audioTitle: {
            type: String,
            default: '音频标题'
        },
        
    },
    data() {
        return {
            // 音频
            audio: {
                // 播放状态
                playing: false,
                // 静音状态
                // muted: false,
                // 音频当前播放时长
                currentTime: 0,
                // 音量
                volume: 1,
                // 音频最大播放时长
                maxTime: 0
            },
            progressState: false,
            audioList: [],
           
            edgeLength: 30,
            Audioindex: 0
        }
    },
    methods: {
        changAudioindex(type) {
            if (type == 'pre') {
                if (this.Audioindex == 0) {

                } else {
                    this.Audioindex--
                }
            } else {
                if (this.Audioindex == this.audioList.length - 1) {

                } else {
                    this.Audioindex++
                }

            }
            this.kcSrc = this.audioList[this.Audioindex].url
            this.audioTitle = this.audioList[this.Audioindex].address
            this.jhSelectid = this.audioList[this.Audioindex].id
            this.audio.playing = false


        },
        realFormatSecond(second) {

            var secondType = typeof second;
            if (secondType === 'number' || secondType === 'string') {
                second = parseInt(second);

                var hours = Math.floor(second / 3600);
                second = second - hours * 3600;
                var mimute = Math.floor(second / 60);
                second = second - mimute * 60;

                return ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
            } else {
                return '00:00'
            }
        },
        // 获取音频长度
        onLoadedmetadata(res) {
            this.audio.maxTime = parseInt(res.target.duration)
        },
        getDuration(res) {
            // console.log(res.target.duration)
            this.audio.maxTime = parseInt(res.target.duration)
        },
        // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
        onTimeupdate(res) {
            // 0,0.1,0.2,...1,1.1,...2,...10
            if (!this.progressState) {
                this.audio.currentTime = res.target.currentTime;
            }
        },
        progressChange(e) {
            this.$refs.audio.currentTime = e;
        },
        // 播放音频
        play() {

            this.$refs.audio.play()
        },
        // 暂停音频
        pause() {
            this.$refs.audio.pause()
        },
        // 当音频播放
        onPlay() {
            this.audio.playing = true
        },
        // 当音频暂停
        onPause() {
            this.audio.playing = false
        },
        // 静音
        mute() {
            this.audio.volume = 0;
            this.audio.muted = true;
            this.$refs.audio.muted = true;
        },
        // 点击音频列表
        changAudio(item, index) {
            this.jhSelectid = item.id
            this.kcSrc = item.url
            this.audioTitle = item.address
            this.audio.playing = false
            this.Audioindex = index

        },
        changeTille(id) {
            this.selecttitle = id
            this.getledgeChilden(id)
            this.page = 1
            this.pageNum = 1
            this.contentShow = false
            this.contentShow2 = false
            this.contentShow3 = false
            this.audio.playing = false

        },
        changePage(data) {
            if (data == 'pre') {
                this.page--
            } else {
                this.page++
            }
            this.getledgeResouce()
        },

    },
    watch: {
            kcSrc(val) {
				
			}
		},
    beforeDestroy() {
        this.audio.playing = false

        if (!!!this.myChart) {
            return
        }
        this.myChart.dispose()
        this.myChart = null
    },
    filters: {
        // 将整数转化成时分秒
        formatSecond(second = 0) {
            return realFormatSecond(second)
        }
    }
}
</script>

<style lang="scss">
.audio_playimg {
    width: 800px;
    height: 97px;
    border-radius: 12px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 10px 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-shadow: 0px 7px 29px 0px rgba(100, 100, 111, 0.2);
}

.audio_playimg_top {
    width: 760px;
    height: 48px;
    line-height: 48px;
    display: flex;
    gap: 20px;
    justify-content: space-between;
    /* background-color: #CD050E; */
}

.audio_play_icon {
    width: 48px;
    height: 48px;
}

.audio_play_icon img {
    width: 100%;
    height: 100%;
}

.audio_play_title {
    height: 100%;
    flex: 1;
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 800;
    line-height: 48px;
    letter-spacing: 0em;
    color: #333333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.audio_paly_progress {
    width: 100%;
    height: 20px;
}
.audio_time {
    width: 100%;
    box-sizing: border-box;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    font-family: PingFang SC;
    font-size: 12px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
    font-variation-settings: "opsz" auto;
    color: #999999;
}

.audio_contrals_progress {
    margin:0 auto;
    width: 98%;
    height: 20px;
}



.audio_contrals_progress .el-slider__button {
    border-color: #B81C1E;
}

 .el-slider__bar {
    background-color: #B81C1E !important;
}

.audio_contrals_progress .el-slider {
    height: 100%;
    position: relative;

}

.el-slider__runway {
  margin: 5px 0;
  /* height: 3px; */
}

.el-slider__button {
    width: 6px !important;
    height: 6px !important;
    background-color: #B81C1E !important;
}</style>
